import {FormModel} from '@xh/hoist/cmp/form';
import {HoistModel, managed} from '@xh/hoist/core';
import {StockChartSettings} from '../../../../data/DataTypes';
import {observableRef} from '@xh/hoist/mobx';

export class ChartSettingsFormModel extends HoistModel {
    @observableRef accessor chartTypes = [];
    @observableRef accessor rangeTypes = [];
    @observableRef accessor instrumentOptions = [];

    @managed formModel: FormModel = new FormModel({
        fields: [
            {
                name: 'ticker'
            },
            {
                name: 'range'
            },
            {
                name: 'type'
            },
            {
                name: 'showVolume'
            },
            {
                name: 'ordinal'
            },
            {
                name: 'showNavigator'
            },
            {
                name: 'indicator'
            },
            {
                name: 'indicatorParams'
            },
            {
                name: 'isLinked'
            }
        ]
    });

    constructor() {
        super();
        this.configureChartTypes();
        this.configureRangeTyeps();
    }

    init(settings: StockChartSettings) {
        if (settings) {
            // Default any field absent from previously-persisted state.
            this.formModel.init({indicatorParams: {}, ...settings});
        } else {
            this.formModel.init({
                range: 'YTD',
                type: 'line',
                showVolume: true,
                indicator: null,
                indicatorParams: {},
                isLinked: false
            });
        }
    }

    getSettings(): StockChartSettings {
        return this.formModel.getData() as StockChartSettings;
    }

    configureChartTypes() {
        this.chartTypes = [
            {value: 'line', label: 'Line'},
            {value: 'area', label: 'Area'},
            {value: 'hlc', label: 'HLC'},
            {value: 'ohlc', label: 'OHLC'},
            {value: 'candlestick', label: 'Candle'},
            {value: 'hollowcandlestick', label: 'Hollow Candle'},
            {value: 'heikinashi', label: 'Heikinashi'}
        ];
    }

    configureRangeTyeps() {
        this.rangeTypes = [
            {value: '1M', label: 'One Month'},
            {value: '3M', label: 'Three Months'},
            {value: '6M', label: 'Six Months'},
            {value: 'YTD', label: 'Year to Date'},
            {value: '1Y', label: 'One Year'},
            {value: 'ALL', label: 'All Available'}
        ];
    }
}
